import {Component, OnInit} from '@angular/core';
import {
  RdsDividerModule,
  RdsHeaderModule,
  RdsSearchModule,
  RdsAlertModule,
  RdsButtonModule,
  RdsIconsModule,
  RdsTooltipModule,
} from "@rds/angular-components";
import {FormsModule} from "@angular/forms";
import { Router, NavigationEnd } from '@angular/router';
import {RdsSearchEvent} from "@rds/core";
import {FilterService} from "../services/filter.service";
import { UserInfoComponent } from "../login/user-info/user-info.component";

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [
    RdsHeaderModule,
    RdsDividerModule,
    RdsSearchModule,
    FormsModule,
    UserInfoComponent,
    RdsAlertModule,
    RdsButtonModule,
    RdsIconsModule,
    RdsTooltipModule,
  ],
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  globalSearch: string = '';
  isAdminPanel: boolean = false;
  url = window.location.href;
  isDev = window.location.href.includes('127') || window.location.href.includes('localhost') || window.location.href.includes('dev');

  constructor(
    private filterService: FilterService,
    private router: Router,
  ) {
    this.filterService.filterData.subscribe(filterData => {
      this.globalSearch = filterData.global;
    })

    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.isAdminPanel = this.router.url.includes('/admin');
      }
    });
  }

  ngOnInit() {
    this.isAdminPanel = this.router.url.includes('/admin');
  }

  onSearchChange(search: RdsSearchEvent){
    this.filterService.updateGlobalSearch(search.query)
  }

  onAppNameTriggered($event: KeyboardEvent|MouseEvent) {
    if (this.router.url !== '/') {
      this.router.navigate(['/']);
    }
  }

  shouldShowTransitionAlert(): boolean {
    const currentDate = new Date();
    const endDate = new Date('2025-10-04');
    return currentDate <= endDate;
  }

}
